import { useRef, useState, useImperativeHandle } from "react";
import React from "react";
import styled from 'styled-components'
import Bonus1 from './imgs/bonus1@2x.png'
import Bonus2 from './imgs/bonus2@2x.png'
import Bonus3 from './imgs/bonus3@2x.png'
import Bonus4 from './imgs/bonus4@2x.png'
import Bonus5 from './imgs/bonus5@2x.png'
import Bonus6 from './imgs/bonus6@2x.png'

// 奖品图片映射
const prizeImages = [Bonus1, Bonus2, Bonus3, Bonus4, Bonus5, Bonus6];
const prizeNames = ['8积分', '大红包', '1天风云VIP', '66积分', '现金红包', '3天风云VIP']

const activeIdxMap = new Map([
    [0, 0],[1,1],[2,2],[3, 5], [4, 4], [5, 3]
])

const LuckyAward = (_, ref) => {
  const [activeIndex, setActiveIndex] = useState(-1); // 当前高亮的奖品索引
  const [isRunning, setIsRunning] = useState(false); // 是否正在抽奖
  const timerRef = useRef(null);

  // 缓动函数：先快后慢
  const easeOut = (t) => {
    return 1 - Math.pow(1 - t, 3); // cubic ease-out
  };

  const handleStart = (prizeIndex, callback) => {
    if (isRunning) return;
    // prizeIndex: 最终中奖的奖品索引 (0-5)
    const targetIndex = prizeIndex !== undefined ? prizeIndex : Math.floor(Math.random() * 6);
    
    setIsRunning(true);
    setActiveIndex(0);

    // 总转动圈数：至少3圈 + 最终位置
    const totalRounds = 3;
    const totalSteps = totalRounds * 6 + activeIdxMap.get(targetIndex); // 总共需要走的步数
    let currentStep = 0;

    // 总时长：3秒
    const totalTime = 3000;
    const startTime = Date.now();

    const run = () => {
      
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / totalTime, 1);
      
      // 使用缓动函数计算当前应该走到的步数
      const easedProgress = easeOut(progress);
      const expectedStep = Math.floor(easedProgress * totalSteps);

      if (currentStep < expectedStep && currentStep < totalSteps) {
        currentStep++;
        const currentIndex = currentStep % 6;
        setActiveIndex(activeIdxMap.get(currentIndex));
      }

      if (progress < 1 && currentStep < totalSteps) {
        timerRef.current = requestAnimationFrame(run);
      } else {
        // 确保最终停在目标位置
        setActiveIndex(targetIndex);
        setIsRunning(false);
        // 抽奖完成，可以在这里添加回调
        setTimeout(() => {
          callback && callback();
        }, 500)
        
      }
    };

    timerRef.current = requestAnimationFrame(run);
  };

  useImperativeHandle(ref, () => {
    return {
      start: (prizeIndex, callback) => {
        handleStart(prizeIndex, callback);
      }
    };
  });

  return (
    <Container>
      <Grid>
        {prizeImages.map((img, index) => (
          <PrizeItem 
            key={index} 
            $active={activeIndex === index}
            $isRunning={isRunning}
						className={(index === 2 || index === 5) ? 'margin-fix' : ''}
          >
						<div className="item-wrap">
							<img src={img} alt="" className="award-img" />
							<PrizeName>{prizeNames[index]}</PrizeName>
							{index === 1 && <div className="max-num">最高88.88元</div>}
						</div>
          </PrizeItem>
        ))}
      </Grid>
    </Container>
  );
};

export default React.memo(React.forwardRef(LuckyAward));

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
	.margin-fix {
		margin-right: 0px !important;
	}
`;

const Grid = styled.div`
  display: flex;
	flex-wrap: wrap;
`;

const PrizeItem = styled.div`
  transition: all 0.1s ease;
	background: #fff;
	border-radius: 20px;
	box-sizing: border-box;
	width: 20.5vw;
	height: 20.5vw;
	margin-right: 12px;
	margin-bottom: 12px;
	position: relative;
	.item-wrap {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #fff;
		z-index: 1;
		border-radius: 20px;
	}

  
  ${props => props.$active && `
    transform: scale(1.05);
    background: #FFFAE0;
    .item-wrap {
        background: #FFFAE0;
    }
		&::before {
			content: '';
			display: block;
			position: absolute;
			width: 100%;
			height: 100%;
			padding: 3px;
			background: yellow;
			left: -3px;
			top: -3px;
			z-index: 0;
			background: linear-gradient(135deg, rgba(254, 255, 11, 1), rgba(255, 83, 83, 1));
			border-radius: 20px;
		}
  `}
  
  .award-img {
    width: 36px;
    height: 36px;
  }

	.max-num {
		font-weight: 400;
		font-size: 8px;
		color: #FD2707;
		line-height: 9px;
		text-align: center;
		margin0-top: 1px;
	}
`;

const PrizeName = styled.div`
  font-weight: 500;
	font-size: 12px;
	color: #222222;
	line-height: 17px;
	text-align: center;
	margin-top: 5px;
	white-space: nowrap;
`;


var easingFuncs = {
  linear: function (k) {
      return k;
  },
  quadraticIn: function (k) {
      return k * k;
  },
  quadraticOut: function (k) {
      return k * (2 - k);
  },
  quadraticInOut: function (k) {
      if ((k *= 2) < 1) {
          return 0.5 * k * k;
      }
      return -0.5 * (--k * (k - 2) - 1);
  },
  cubicIn: function (k) {
      return k * k * k;
  },
  cubicOut: function (k) {
      return --k * k * k + 1;
  },
  cubicInOut: function (k) {
      if ((k *= 2) < 1) {
          return 0.5 * k * k * k;
      }
      return 0.5 * ((k -= 2) * k * k + 2);
  },
  quarticIn: function (k) {
      return k * k * k * k;
  },
  quarticOut: function (k) {
      return 1 - (--k * k * k * k);
  },
  quarticInOut: function (k) {
      if ((k *= 2) < 1) {
          return 0.5 * k * k * k * k;
      }
      return -0.5 * ((k -= 2) * k * k * k - 2);
  },
  quinticIn: function (k) {
      return k * k * k * k * k;
  },
  quinticOut: function (k) {
      return --k * k * k * k * k + 1;
  },
  quinticInOut: function (k) {
      if ((k *= 2) < 1) {
          return 0.5 * k * k * k * k * k;
      }
      return 0.5 * ((k -= 2) * k * k * k * k + 2);
  },
  sinusoidalIn: function (k) {
      return 1 - Math.cos(k * Math.PI / 2);
  },
  sinusoidalOut: function (k) {
      return Math.sin(k * Math.PI / 2);
  },
  sinusoidalInOut: function (k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
  },
  exponentialIn: function (k) {
      return k === 0 ? 0 : Math.pow(1024, k - 1);
  },
  exponentialOut: function (k) {
      return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
  },
  exponentialInOut: function (k) {
      if (k === 0) {
          return 0;
      }
      if (k === 1) {
          return 1;
      }
      if ((k *= 2) < 1) {
          return 0.5 * Math.pow(1024, k - 1);
      }
      return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
  },
  circularIn: function (k) {
      return 1 - Math.sqrt(1 - k * k);
  },
  circularOut: function (k) {
      return Math.sqrt(1 - (--k * k));
  },
  circularInOut: function (k) {
      if ((k *= 2) < 1) {
          return -0.5 * (Math.sqrt(1 - k * k) - 1);
      }
      return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
  },
  elasticIn: function (k) {
      var s;
      var a = 0.1;
      var p = 0.4;
      if (k === 0) {
          return 0;
      }
      if (k === 1) {
          return 1;
      }
      if (!a || a < 1) {
          a = 1;
          s = p / 4;
      }
      else {
          s = p * Math.asin(1 / a) / (2 * Math.PI);
      }
      return -(a * Math.pow(2, 10 * (k -= 1))
          * Math.sin((k - s) * (2 * Math.PI) / p));
  },
  elasticOut: function (k) {
      var s;
      var a = 0.1;
      var p = 0.4;
      if (k === 0) {
          return 0;
      }
      if (k === 1) {
          return 1;
      }
      if (!a || a < 1) {
          a = 1;
          s = p / 4;
      }
      else {
          s = p * Math.asin(1 / a) / (2 * Math.PI);
      }
      return (a * Math.pow(2, -10 * k)
          * Math.sin((k - s) * (2 * Math.PI) / p) + 1);
  },
  elasticInOut: function (k) {
      var s;
      var a = 0.1;
      var p = 0.4;
      if (k === 0) {
          return 0;
      }
      if (k === 1) {
          return 1;
      }
      if (!a || a < 1) {
          a = 1;
          s = p / 4;
      }
      else {
          s = p * Math.asin(1 / a) / (2 * Math.PI);
      }
      if ((k *= 2) < 1) {
          return -0.5 * (a * Math.pow(2, 10 * (k -= 1))
              * Math.sin((k - s) * (2 * Math.PI) / p));
      }
      return a * Math.pow(2, -10 * (k -= 1))
          * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
  },
  backIn: function (k) {
      var s = 1.70158;
      return k * k * ((s + 1) * k - s);
  },
  backOut: function (k) {
      var s = 1.70158;
      return --k * k * ((s + 1) * k + s) + 1;
  },
  backInOut: function (k) {
      var s = 1.70158 * 1.525;
      if ((k *= 2) < 1) {
          return 0.5 * (k * k * ((s + 1) * k - s));
      }
      return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
  },
  bounceIn: function (k) {
      return 1 - easingFuncs.bounceOut(1 - k);
  },
  bounceOut: function (k) {
      if (k < (1 / 2.75)) {
          return 7.5625 * k * k;
      }
      else if (k < (2 / 2.75)) {
          return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
      }
      else if (k < (2.5 / 2.75)) {
          return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
      }
      else {
          return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
      }
  },
  bounceInOut: function (k) {
      if (k < 0.5) {
          return easingFuncs.bounceIn(k * 2) * 0.5;
      }
      return easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
  }
};